export const PUZZLES = [
  "e7cb5644",
  "25c55590",
  "2a704fd0",
  "5772a2fd",
  "ec1b839c",
  "0c2545d9",
  "500703c4",
  "1ddedad5",
];

export const PIECES: [string, number[]][] = [
  ["59df0a26", [1, 1, 0, 0, 0, 1, 0, 0]],
  ["a9f19264", [0, 0, 0, 0, 1, 0, 0, 1]],
  ["c79b3dc8", [0, 0, 0, 0, 0, 1, 1, 0]],
  ["a255e875", [0, 0, 0, 0, 1, 0, 1, 0]],
  ["e158ce4a", [1, 0, 1, 0, 0, 1, 1, 0]],
  ["76a4675d", [1, 0, 0, 0, 1, 1, 0, 1]],
  ["085110e3", [1, 1, 0, 0, 1, 0, 0, 1]],
  ["3428c634", [0, 0, 0, 0, 1, 1, 0, 1]],
  ["ad3e2c7e", [1, 0, 1, 0, 1, 0, 1, 1]],
  ["ccd5092a", [1, 0, 0, 0, 1, 1, 1, 1]],
  ["07b6cb60", [1, 0, 1, 0, 0, 1, 0, 0]],
  ["2e8a0d2f", [0, 0, 1, 0, 1, 1, 0, 1]],
  ["d09109e2", [1, 1, 1, 0, 0, 1, 1, 0]],
  ["14fac868", [0, 0, 0, 0, 1, 0, 0, 0]],
  ["f0e3c0db", [1, 0, 0, 0, 0, 1, 1, 0]],
  ["9e817293", [1, 0, 0, 0, 1, 0, 0, 0]],
  ["26951283", [1, 0, 0, 0, 1, 0, 1, 1]],
  ["3c341b4d", [0, 0, 0, 0, 1, 1, 0, 0]],
  ["3e6f8c64", [1, 1, 0, 0, 1, 0, 0, 0]],
  ["ffe34b6e", [1, 0, 0, 0, 1, 1, 0, 0]],
  ["51b29790", [1, 0, 0, 1, 0, 0, 1, 0]],
  ["5e03faa8", [0, 0, 0, 1, 1, 0, 0, 1]],
  ["09594596", [0, 0, 0, 1, 0, 1, 0, 0]],
  ["19d0d859", [0, 0, 0, 1, 1, 0, 0, 0]],
  ["db24e6d4", [1, 1, 0, 1, 0, 1, 0, 0]],
];

export const PIECE_ALT_NAME = {
  "59df0a26": "C",
  "76a4675d": "S",
  "3428c634": "E",
  ad3e2c7e: "L",
  ccd5092a: "A",
  "07b6cb60": "I",
  f0e3c0db: "K",
  "26951283": "N",
  "5e03faa8": "O",
  "19d0d859": "T",
  db24e6d4: "R",
};

export const POINTING_TO = {
  a9f19264: "59df0a26",
  c79b3dc8: "ad3e2c7e",
  a255e875: "3428c634",
  e158ce4a: "ccd5092a",
  "085110e3": "26951283",
  "2e8a0d2f": "76a4675d",
  d09109e2: "3428c634",
  "14fac868": "ad3e2c7e",
  "9e817293": "07b6cb60",
  "3c341b4d": "26951283",
  "3e6f8c64": "f0e3c0db",
  ffe34b6e: "db24e6d4",
  "51b29790": "5e03faa8",
  "09594596": "19d0d859",
};
